import { render, staticRenderFns } from "./TradeDueToDelivery.vue?vue&type=template&id=2c8c0c03&scoped=true"
import script from "./TradeDueToDelivery.vue?vue&type=script&lang=js"
export * from "./TradeDueToDelivery.vue?vue&type=script&lang=js"
import style0 from "./TradeDueToDelivery.vue?vue&type=style&index=0&id=2c8c0c03&prod&scoped=true&lang=scss"
import style1 from "./TradeDueToDelivery.vue?vue&type=style&index=1&id=2c8c0c03&prod&lang=css"
import style2 from "./TradeDueToDelivery.vue?vue&type=style&index=2&id=2c8c0c03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c0c03",
  null
  
)

export default component.exports